import { __assign } from "tslib";
import React, { useEffect, useState } from 'react';
import { SecureHtml } from '@wix/wix-emails-secure-components';
import { WrapperItem } from '../components/wrapper-item';
import { Section } from '../components/section';
import { Text } from '../components/text';
import { Column } from '../components/column';
import { shorthand } from '../utils/css-utils';
export var textCssClasses = {
    text: 'html-emails-text-wrapper',
};
export function SectionText(props) {
    var section = props.section, cssClass = props.cssClass, isRtl = props.isRtl, columnCssClass = props.columnCssClass, experiments = props.experiments;
    var outerPadding = section.outerPadding, innerPadding = section.innerPadding, textBackground = section.textBackground;
    var _a = useState({
        dir: isRtl ? 'rtl' : undefined,
        style: {
            textAlign: section.align,
        },
    }), textContainerProps = _a[0], setTextContainerProps = _a[1];
    useEffect(function () {
        setTextContainerProps({
            dir: isRtl ? 'rtl' : undefined,
            style: {
                textAlign: section.align,
            },
        });
    }, [isRtl, section.align]);
    var baseTextProps = {
        align: section.align,
        color: section.color,
        cssClass: textCssClasses.text,
        fontFamily: section.fontFamily,
        fontSize: section.fontSize,
        fontStyle: section.fontStyle,
        textTransform: section.textTransform,
    };
    var defaultProps = { padding: '0px' };
    var combinedTextProps = __assign({}, __assign(__assign({}, defaultProps), baseTextProps));
    combinedTextProps.align = undefined;
    return (React.createElement(WrapperItem, null,
        React.createElement(Section, { backgroundColor: section.backgroundColor, borderBottom: section.borderBottom, borderLeft: section.borderLeft, borderRight: section.borderRight, borderTop: section.borderTop, cssClass: cssClass, padding: shorthand(outerPadding) },
            React.createElement(Column, { padding: shorthand(innerPadding), cssClass: columnCssClass, backgroundColor: textBackground.backgroundColor, border: textBackground.border, borderRadius: textBackground.borderRadius },
                React.createElement(Text, __assign({}, combinedTextProps),
                    React.createElement(SecureHtml, { html: section.html, containerProps: textContainerProps, skipCleaning: experiments['specs.so.public.Sanitize'] !== 'true' }))))));
}
//# sourceMappingURL=section-text.js.map